import { HttpRequest } from "@angular/common/http";

export function attachTokenToRequest(request: HttpRequest<any>, token: string) {
    // Check if the user is logging in for the first time
    if (token) {
        return request.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
    }
    else {
        return request.clone();
    }
}